import { AllColours } from "../../boardTypes";
import type { Tile } from "../../../types/tile";
import type { TileGrouper } from ".";

export const groupByColours: TileGrouper = (tiles) => {
    // Sort by tile tile, then colour
    tiles.sort((a, b) => a.TileType - b.TileType);
    tiles.sort((a, b) => a.Colour - b.Colour);

    let outputTiles: Tile[][] = [];

    for (const colour of AllColours()) {
        const tilesOfThisColour = tiles.filter(
            (tile) => tile.Colour === colour
        );

        if (tilesOfThisColour.length > 0)
            outputTiles = [...outputTiles, tilesOfThisColour];
    }

    return outputTiles;
};
